import React, { useEffect } from 'react';
import { Tabs, Avatar, Drawer } from 'antd';
import { CloseOutlined, MailOutlined, PhoneOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import ShortListedConfig from '../entity/HRM/pre-onboarding/shortlistedConfig';
import { getData } from '../actions/apiCall';
import { constants } from '../constants/common';

const { TabPane } = Tabs;

const CandidateScreening: React.FC = () => {
    const [visible, setVisible] = React.useState(false);
    const app = useSelector((state: any) => state.app);
    const dispatch = useDispatch();
    const [userData, setUserData] = React.useState(null);

    useEffect(() => {
        if (app?.candidateId) {
            getCandidateDetails(app?.candidateId)
        } else {
            setVisible(false);
        }
    }, [app?.candidateId]);


    const getCandidateDetails = async (candidateId) => {
        try {
            const resData = await dispatch(getData(ShortListedConfig.api() + '/no_level/' + candidateId, {}))
            if (resData?.code === 200) {
                setUserData(resData?.data);
                setVisible(true);
            } else {
                console.error("Failed to fetch candidate details.");
            }
        } catch (error) {
            console.error("Error fetching candidate details:", error);
        }
    };


    const calculatePercentage = (currentSalary, expectedSalary) => {
        if (currentSalary === 0) return 0;
        const difference = expectedSalary - currentSalary;
        const percentageChange = (difference / currentSalary) * 100;
        return percentageChange.toFixed(2); // Return percentage with 2 decimal places
    }

    const handleClose = () => {
        dispatch({ type: constants.CANDIDATE_ID, payload: null });
    };


    return (
        <Drawer
            title={
                <div className="flex justify-between items-center">
                    <h2 className="text-lg font-semibold">Candidate Details</h2>
                    <CloseOutlined className="text-gray-500 hover:text-gray-700 cursor-pointer" onClick={() => handleClose()} />
                </div>
            }
            placement="right"
            maskClosable={false}
            onClose={() => handleClose()}
            open={visible}
            width={400}
            styles={{
                body: { padding: 0, height: '100%' },
            }}
        >
            <div className="flex px-6 h-full w-full">
                {/* <div className="w-1/4 border-r"> */}
                <div className="w-full">
                    <div className="mb-6 py-4 pr-4">
                        <div className='text-gray-500 text-sm'>#Applicant</div>
                        <h2 className="text-xl font-semibold">{userData?.appliedFor?.jobTitle?.name}</h2>
                        <p className="mt-2 flex justify-between">
                            <div>
                                Experience
                            </div>
                            <div className='font-semibold'>
                                {userData?.experiance}+ Year
                            </div>
                        </p>
                        <p className="mt-2 flex justify-between">
                            <div>
                                CTC
                            </div>
                            <div className='font-semibold'>
                                INR {userData?.currentCTC}
                            </div>
                        </p>
                        <p className="mt-2 flex justify-between">
                            <div>
                                E-CTC ({calculatePercentage(userData?.currentCTC, userData?.expectedCTC)}%)
                            </div>
                            <div className='font-semibold'>
                                INR {userData?.expectedCTC}
                            </div>
                        </p>
                        <p className="mt-2 flex justify-between">
                            <div>
                                Notice Period
                            </div>
                            <div className='font-semibold'>
                                {userData?.noticePeriod} Days
                            </div>
                        </p>
                    </div>

                    <div className="mb-6">
                        <div className='border-b pb-0 mb-4'>
                            <h3 className="text-lg font-semibold mb-2">Contact Details</h3>
                        </div>
                        <div className='flex flex-col py-4 pr-4 gap-4'>
                            <div className="flex items-center gap-2">
                                <Avatar size={30} src="https://via.placeholder.com/64" />
                                <div className="text-gray-600">
                                    <p className="font-medium">{constants.GET_FULL_NAME(userData)}</p>
                                </div>
                            </div>
                            <div className="flex items-center text-gray-600 gap-2">
                                <div className='flex items-center text-center w-8 h-8 rounded-full bg-gray-200'>
                                    <MailOutlined className='m-auto' />
                                </div>
                                <span>{userData?.email}</span>
                            </div>
                            <div className="flex items-center text-gray-600 gap-2">
                                <div className='flex items-center text-center w-8 h-8 rounded-full bg-gray-200'>
                                    <PhoneOutlined className='m-auto' />
                                </div>
                                <span>+91 {userData?.phone}</span>
                            </div>
                        </div>
                    </div>

                    {/* HR Details */}
                    <div className='py-4'>
                        <div className='border-b pb-0 mb-4'>
                            <h3 className="text-lg font-semibold mb-2">HR</h3>
                        </div>
                        <div className="flex items-center pr-4 gap-2">
                            <Avatar size={30} src="https://via.placeholder.com/48" />
                            <div>
                                <p className="font-medium">Ajay Sharma</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right Panel */}
                {/* <div className="w-3/4 pl-4 py-4">
                    <div className="flex justify-between items-center mb-4">
                        <div>
                            <span className="font-semibold">Stage :</span> Screening
                        </div>
                        <div className="text-gray-500 text-sm">
                            been this stage for 48 minutes
                        </div>
                    </div>

                    <Tabs defaultActiveKey="1" type="line">
                        <TabPane tab="Screening" key="0">
                            <>
                            </>
                        </TabPane>
                        <TabPane tab="Note's" key="2">
                            Notes content here
                        </TabPane>
                        <TabPane tab="Experience" key="4">
                            Experience content here
                        </TabPane>
                        <TabPane tab="Feedback's" key="5">
                            Feedbacks content here
                        </TabPane>
                        <TabPane tab="Attachments" key="6">
                            Attachments content here
                        </TabPane>
                        <TabPane tab="Activities" key="7">
                            Activities content here
                        </TabPane>
                        <TabPane tab="Documents" key="8">
                            Documents content here
                        </TabPane>
                    </Tabs>
                </div> */}

            </div>
        </Drawer>
    );
};

export default CandidateScreening;
